import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";

// Shared international phone input for ALL YANRE public lead forms.
// libphonenumber-js (real country numbering plans) drives country detection,
// per-country formatting and validation; the stored value is always
// normalized E.164 (e.g. +351912345678) — no spaces, parentheses or hyphens.
//
// `country` is a SUGGESTION (defaultCountry): national numbers typed without
// a "+" prefix are interpreted for that country, the flag selector stays free
// for the visitor to change at any time, and international input (+55 …)
// always works. The key-based remount applies a new suggestion cleanly;
// the controlled E.164 value survives remounts.
// `onUserCountrySelect` fires only on a genuine user pick (DOM change event
// on the country <select>), letting forms stop auto-suggesting afterwards.
export { isValidPhoneNumber };

export const PhoneIntl = ({ value, country, onChange, onCountryChange, onUserCountrySelect, invalid, inputTestId, selectTestId }) => (
  <div className={`yanre-phone${invalid ? " yanre-phone-invalid" : ""}`} data-testid={inputTestId ? `${inputTestId}-intl` : undefined}>
    <PhoneInput
      key={country || "none"}
      international
      countryCallingCodeEditable={false}
      defaultCountry={country || undefined}
      onCountryChange={(c) => onCountryChange?.(c || "")}
      value={value}
      onChange={(v) => onChange(v || "")}
      countrySelectProps={{
        "data-testid": selectTestId,
        "aria-label": "Phone country",
        onChange: () => onUserCountrySelect?.(),
      }}
      numberInputProps={{ "data-testid": inputTestId, autoComplete: "tel", inputMode: "tel" }}
    />
  </div>
);
